import React from 'react';
import './App.css';
import TermsOfService from './TermsOfService';

function App() {
  return (
    <div className="App">
      <TermsOfService />
    </div>
  );
}

export default App;
